import { Injectable, HostListener, OnDestroy } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Subject } from 'rxjs';
import 'rxjs/Rx';

import { AppConfigService } from '../app.config';

@Injectable()
export class SearchDocusignService {

    _error$: Subject<any> = <Subject<any>>new Subject();
    _collection$: Subject<any[]> = <Subject<any[]>>new Subject();
    // _item$: Subject<any> = <Subject<any>>new Subject();
    // _forms$: Subject<any[]> = <Subject<any[]>>new Subject();

    get collection$() { return this._collection$.asObservable(); }
    // get item$() { return this._item$.asObservable(); }
    get error$() { return this._error$.asObservable(); }
    // get forms$() { return this._forms$.asObservable(); }

    constructor(private config: AppConfigService, private http: Http) {}
    searchEmail(value: string) {
        this.http.get(`${this.config.url}/docusign/search-email/${value}`,
            { headers: this.getHeaders() }).map( (response: any) => response.json()).subscribe(
            (data: any[]) => {
                this._collection$.next(data);
            },
            (error: any) => {
                console.log(`Could not post search.`, error);
                this._error$.next(error);
            });
    }

    searchName(fname: string, lname: string) {
        this.http.get(`${this.config.url}/docusign/search-name/${fname}/${lname}`,
            { headers: this.getHeaders() }).map( (response: any) => response.json()).subscribe(
            (data: any[]) => {
                this._collection$.next(data);
            },
            (error: any) => {
                console.log(`Could not post search.`, error);
                this._error$.next(error);
            });
    }

    getHeaders(): Headers {
        const contentHeaders = new Headers();
        contentHeaders.append('Accept', 'application/json');
        contentHeaders.append('Content-Type', 'application/json');
        contentHeaders.append('Authorization', this.config.token);
        return  contentHeaders;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/search-docusign.ts